import React, { useReducer, useContext } from "react";
import axios from "axios";
import moment from "moment";
import { get } from "lodash";
import LeadContext from "./leadContext";
import LeadReducer from "./LeadReducer";
import {
    SET_LOADING,
    GET_LEAD_COUNTS,
    GET_LEAD_DEALERS,
    GET_DEALER_LEADS,
    GET_LEADS,
    GET_LEAD,
    GET_LEAD_PAGE,
    LEAD_STATUS_UPDATED,
    SET_ACTIVE_PAGE_VALUE,
    SET_LEAD_DEALERS_PAGE,
    SET_DEALER_LEADS_PAGE,
    SET_LEAD_PAGE,
    SET_LEAD_FILTER_VALUE
} from "../types";
import SearchContext from "../search/searchContext";
import { checkLeadFilter } from "../../tables/leadFilterOptions";
import { replaceHyphens, checkFilter } from "../../utils/utils";

const LeadState = (props) => {
    const searchContext = useContext(SearchContext);
    const { startDateMySQL, endDateMySQL, paginationValue } = searchContext;

    const initialState = {
        lead: {},
        leadLinks: {},
        leadCount: 0,
        leadDealerCount: 0,
        leadCounts: [],
        leads: [],
        leadDealers: [],
        loading: false,
        leadFilterValue: "all",
        activePage: 1,
        leadsPage: 1,
        dealerLeadsPage: 1,
        leadDealersPage: 1,
        leadLoading: false,
    };

    const [state, dispatch] = useReducer(LeadReducer, initialState);

    /**
     * @param {string} filter
     * @return {undefined}
     */
    const setLeadFilterValue = (filter) => {
        dispatch({
            type: SET_LEAD_FILTER_VALUE,
            payload: filter,
        });
    };

    /**
     * Ensure the filter value passed is a leadFilter
     * if not, set default filter instead
     *
     * @param {string} rawFilter
     * @return {undefined}
     */
    const setLeadFilterOrDefault = (rawFilter) => {
        const filter = checkLeadFilter(replaceHyphens(rawFilter));
        setLeadFilterValue(filter);
    };

    // deprecated?
    const setActivePage = (pageNumber) => {
        dispatch({
            type: SET_ACTIVE_PAGE_VALUE,
            payload: pageNumber,
        });
    };

    /**
     * @param {integer} pageNumber
     * @return {undefined}
     */
    const setLeadPage = (pageNumber) => {
        dispatch({
            type: SET_LEAD_PAGE,
            payload: pageNumber,
        });
    };

    /**
     * @param {integer} pageNumber
     * @return {undefined}
     */
    const setDealerLeadsPage = (pageNumber) => {
        dispatch({
            type: SET_DEALER_LEADS_PAGE,
            payload: pageNumber,
        });
    };

    /**
     * @param {integer} pageNumber
     * @return {undefined}
     */
    const setLeadDealersPage = (pageNumber) => {
        dispatch({
            type: SET_LEAD_DEALERS_PAGE,
            payload: pageNumber,
        });
    };

    const getLeadCounts = async () => {
        setLoading();
        const res = await axios.get(
            `/api/v1/lead/counts/${startDateMySQL}/${endDateMySQL}`
        );
        dispatch({
            type: GET_LEAD_COUNTS,
            payload: get(res, "data", {}),
        });
    };

    const getLeadDealers = async ({
        leadFilterValue: leadFilterValueRaw,
        start,
        end,
    }) => {
        const filter = replaceHyphens(leadFilterValueRaw);

        setLoading();
        const res = await axios.get(
            `/api/v1/lead-dealers/${filter}/${start}/${end}?pagination=${paginationValue}&page=${state.leadDealersPage}`
        );
        dispatch({
            type: GET_LEAD_DEALERS,
            payload: get(res, "data", {}),
        });
    };

    /**
     * param {string}   leadFilterValue (object prop)
     * param {integer}  id (object prop)
     * return {undefined}
     */
    const getDealerLeads = async ({
        leadFilterValue: leadFilterValueRaw,
        id,
    }) => {
        const filter = replaceHyphens(leadFilterValueRaw);

        setLoading();
        const res = await axios.get(
            `/api/v1/lead/dealer/${id}/${filter}/${startDateMySQL}/${endDateMySQL}?pagination=${paginationValue}&page=${state.dealerLeadsPage}`
        );

        dispatch({
            type: GET_DEALER_LEADS,
            payload: get(res, "data", {}),
        });
    };

    /**
     * param {string} leadFilterValue (object prop)
     * return {undefined}
     */
    const getLeads = async ({
        leadFilterValue: leadFilterValueRaw,
        start,
        end,
    }) => {
        const filter = replaceHyphens(leadFilterValueRaw);

        setLoading();
        const res = await axios.get(
            `/api/v1/leads/${filter}/${start}/${end}?pagination=${paginationValue}&page=${state.leadsPage}`
        );
        dispatch({
            type: GET_LEADS,
            payload: get(res, "data", {}),
        });
    };

    /**
     * param {integer} pageNumber
     * return {undefined}
     */
    const getLeadPage = async (pageNumber) => {
        setLoading();
        const res = await axios.get(
            `/api/v1/leads/${startDateMySQL}/${endDateMySQL}?page=${pageNumber}`
        );
        dispatch({
            type: GET_LEAD_PAGE,
            payload: get(res, "data", {}),
        });
    };

    const setLoading = () => dispatch({ type: SET_LOADING });

    return (
        <LeadContext.Provider
            value={{
                lead: state.lead,
                leadLoading: state.leadLoading,
                leads: state.leads,
                leadDealers: state.leadDealers,
                leadLinks: state.leadLinks,
                leadCount: state.leadCount,
                leadCounts: state.leadCounts,
                leadDealerCount: state.leadDealerCount,
                loading: state.loading,
                activePage: state.activePage, // deprecated?
                leadsPage: state.leadsPage,
                dealerLeadsPage: state.dealerLeadsPage,
                leadDealersPage: state.leadDealersPage,
                leadFilterValue: state.leadFilterValue,
                setLeadPage,
                setLeadFilterValue,
                setLeadFilterOrDefault,
                setDealerLeadsPage,
                setLeadDealersPage,
                setActivePage,
                getLeadPage,
                setLoading,
                getLeads,
                getLeadCounts,
                getLeadDealers,
                getDealerLeads,
            }}
        >
            {props.children}
        </LeadContext.Provider>
    );
};

export default LeadState;
